/**
 * Holster cart drawer preview helpers:
 * 1) Live shipping countdown (cutoff 14:00 Europe/Berlin, Mon–Sat; ships next shipping day Mon–Sat, Sunday no shipping/delivery) + delivery estimate.
 * 2) Drawer consistency guard: after any cart add/change, compare /cart.js keys
 *    with rendered rows; if an item is missing, re-render drawer via Section Rendering API.
 */
(function (window, document) {
  'use strict';
  if (window.__holsterCartPreview) return;
  window.__holsterCartPreview = true;

  var SECTION = 'cart-drawer-section';
  var DAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  /* ---------- Versand-Countdown (Europe/Berlin, Cutoff 14:00 Mo–Sa, Versand am nächsten Versandtag Mo–Sa; Sonntag kein Versand/keine Zustellung) ---------- */
  var TZ = 'Europe/Berlin';
  var CUTOFF_H = 14;
  var WDL = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var fmtParts = null;
  try {
    fmtParts = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  } catch (e) {}
  // Berlin-Wanduhrzeit eines Instants als UTC-codierte ms
  function wall(ms) {
    if (!fmtParts) return ms;
    var p = {};
    fmtParts.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
  }
  // Berlin-Wanduhrzeit -> echter Instant (DST-korrekt)
  function instant(w) {
    var t = w - (wall(w) - w);
    return w - (wall(t) - t);
  }
  function wd(w) { return new Date(w).getUTCDay(); }
  function isBizW(w) { return wd(w) !== 0; } // Versand- und Zustelltage: Mo–Sa
  function dayStart(w) { var d = new Date(w); return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()); }
  function nextBiz(w) { var x = dayStart(w); do { x += 864e5; } while (!isBizW(x)); return x; }
  function addBizW(w, n) { var x = dayStart(w); while (n > 0) { x += 864e5; if (isBizW(x)) n--; } return x; }
  function fmtW(w) { var d = new Date(w); return DAYS[d.getUTCDay()] + ', ' + ('0' + d.getUTCDate()).slice(-2) + '.' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '.'; }
  function shipInfo(nowMs) {
    var nw = wall(nowMs);
    var today = dayStart(nw);
    var cutDay = (isBizW(today) && nw < today + CUTOFF_H * 36e5) ? today : nextBiz(today);
    var shipDay = nextBiz(cutDay);
    var left = Math.max(0, instant(cutDay + CUTOFF_H * 36e5) - nowMs);
    return { left: left, shipDay: shipDay, today: today };
  }
  function countdownHTML(nowMs) {
    var s = shipInfo(nowMs);
    var t = Math.floor(s.left / 1000);
    var h = Math.floor(t / 3600), m = Math.floor(t % 3600 / 60), sec = t % 60;
    var when = s.shipDay === s.today + 864e5 ? 'morgen' : 'am ' + WDL[wd(s.shipDay)];
    return 'Bestelle in <b>' + h + ' Std. ' + m + ' Min. ' + sec + ' Sek.</b> – Versand ' + when + '.';
  }
  function deliveryText(nowMs) {
    var s = shipInfo(nowMs || Date.now());
    return 'Lieferung voraussichtlich ' + fmtW(addBizW(s.shipDay, 1)) + ' – ' + fmtW(addBizW(s.shipDay, 2));
  }
  function fillDelivery() {
    var now = Date.now();
    var t = deliveryText(now);
    document.querySelectorAll('[data-holster-delivery-range]').forEach(function (n) {
      if (n.textContent !== t) n.textContent = t;
    });
    var c = countdownHTML(now);
    document.querySelectorAll('[data-holster-countdown]').forEach(function (n) {
      if (n.innerHTML !== c) n.innerHTML = c;
    });
  }

  /* ---------- drawer consistency guard ---------- */
  function drawerInner() {
    return document.querySelector('#cart-drawer .cart-drawer__inner');
  }
  function renderedKeys() {
    var inner = drawerInner();
    if (!inner) return null;
    var keys = {};
    inner.querySelectorAll('.cart-items__table-row[data-key]').forEach(function (r) {
      keys[r.getAttribute('data-key')] = true;
    });
    return keys;
  }
  var busy = false;
  var pending = false;
  function verify() {
    if (busy) { pending = true; return; }
    busy = true;
    fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var keys = renderedKeys();
        if (!keys) return;
        var items = cart.items || [];
        var missing = items.some(function (i) { return !keys[i.key]; });
        var extra = Object.keys(keys).length !== items.length;
        if (!missing && !extra) return;
        return fetch(root() + '?sections=' + SECTION, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data && data[SECTION];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('.cart-drawer__inner');
            var inner = drawerInner();
            if (!fresh || !inner) return;
            inner.className = fresh.className;
            inner.innerHTML = fresh.innerHTML;
            document.querySelectorAll('cart-icon').forEach(function (icon) {
              try { if (icon.renderCartBubble) icon.renderCartBubble(cart.item_count, false); } catch (e) {}
            });
            document.dispatchEvent(new CustomEvent('holster:cart:rerendered', { detail: { cart: cart } }));
            fillDelivery();
          });
      })
      .catch(function () {})
      .finally(function () {
        busy = false;
        if (pending) { pending = false; window.setTimeout(verify, 300); }
      });
  }
  var vt = null;
  function scheduleVerify(delay) {
    window.clearTimeout(vt);
    vt = window.setTimeout(verify, delay || 700);
  }

  function boot() {
    fillDelivery();
    window.setInterval(fillDelivery, 1000);
    ['cart:update', 'cart:change', 'shopify:cart:lines-update', 'cart-drawer:refreshed', 'theme:cart:change']
      .forEach(function (ev) { document.addEventListener(ev, function () { scheduleVerify(700); fillDelivery(); }); });

    // Observe network: any /cart/add|change|update request (theme, FBT, upsell, apps)
    if (window.PerformanceObserver) {
      try {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (e) {
            if (/\/cart\/(add|change|update)(\.js)?/.test(e.name)) scheduleVerify(600);
          });
        }).observe({ type: 'resource', buffered: false });
      } catch (e) {}
    }

    // Verify when the drawer opens
    var drawer = document.getElementById('cart-drawer');
    var dialog = drawer && drawer.querySelector('dialog');
    if (dialog && window.MutationObserver) {
      new MutationObserver(function () {
        if (dialog.hasAttribute('open')) { fillDelivery(); scheduleVerify(250); }
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }
    if (drawer && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        if (t) return;
        t = window.setTimeout(function () { t = null; fillDelivery(); }, 150);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.HolsterCartPreview = { verify: verify, deliveryText: deliveryText };
})(window, document);
